export const TELEMETRY_SOURCE = {
	notDefined: 0,
	cellPhone: 1,
	hardware: 2,
} as const;

export type TelemetrySource =
	(typeof TELEMETRY_SOURCE)[keyof typeof TELEMETRY_SOURCE];

export type UpdateVehicleTelemetryRequest = {
	telemetrySource: TelemetrySource;
};

export type TelemetryCardProps = {
	vehicleId: string;
	telemetrySource?: TelemetrySource | null;
};
